import {
    ADD_LOCAL_STORED_BETS,
    DECREMENT_BET_VALUE,
    INCREMENT_BET_VALUE,
    REMOVE_ALL_BETS,
    REMOVE_OPEN_BET,
    TOGGLE_COMMIT_BETS_ERROR,
    TOGGLE_COMMIT_BETS_SUCCESS,
    TOGGLE_COMMITTING_BETS
} from '../constants/actionTypes';
import {BET_LIMITS} from '../../../constants/betLimits';
import defaultStoreValues from '../../../constants/defaultStoreValues';
import {compareBetRacers, updateSimplifiedLocalOpenBets} from '../helpers/betHelpers';
import {getOpenBetMessage} from '../helpers/messageBarHelper';

export default (state, action) => {
    let newOpenBetsList;
    let newOpenBetsHistory;
    let newMessageBar;
    let newGames;
    switch (action.type) {
        case INCREMENT_BET_VALUE:
            newOpenBetsList = state.openBetsList.slice();
            newOpenBetsHistory = state.openBetsHistory.slice();

            // check if the bet already exists
            let bet = newOpenBetsList.find((openBet) => openBet.game.channel === action.bet.game.channel && openBet.event.eventId === action.bet.event.eventId && openBet.market.id === action.bet.market.id && compareBetRacers(openBet.racers, action.bet.racers));
            if (bet) {
                let newBetStake = bet.stake + action.value;
                if (newBetStake > BET_LIMITS.maxStake || newBetStake < BET_LIMITS.minStake) {
                    return state;
                }

                bet.stake += action.value;
                newMessageBar = getOpenBetMessage(INCREMENT_BET_VALUE, bet);
            } else {
                action.bet.stake += action.value;
                newOpenBetsList.push(action.bet);
                newMessageBar = getOpenBetMessage(INCREMENT_BET_VALUE, action.bet);
            }

            newOpenBetsHistory.push(action.betHistory);

            // store bets locally
            updateSimplifiedLocalOpenBets(state.playerUID, newOpenBetsList, newOpenBetsHistory);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsHistory: newOpenBetsHistory,
                messageBar: newMessageBar
            };

        case DECREMENT_BET_VALUE:
            // if the bet event is in no more bets, nothing will be done here
            if (state.noMoreBetsEventList.find((nmbEv) => nmbEv.eventId === action.openBet.event.eventId)) {
                return state;
            }

            let lastBetAction = state.openBetsHistory[state.openBetsHistory.length - 1];
            action.openBet.stake -= lastBetAction.value;

            newOpenBetsList = state.openBetsList.slice();
            newOpenBetsHistory = state.openBetsHistory.slice();

            // go backwards on history until we find the last bet history for the selected event / channel
            for (let i = newOpenBetsHistory.length - 1; i >= 0; i--) {
                if (newOpenBetsHistory[i].event.eventId === action.eventId && newOpenBetsHistory[i].game.channel === action.channel) {
                    newOpenBetsHistory.splice(i, 1);
                    break;
                }
            }

            // override the open bet by the one with updated stake
            for (let i = 0; i < newOpenBetsList.length; i++) {
                if (newOpenBetsList[i].game.channel === action.openBet.game.channel && newOpenBetsList[i].event.eventId === action.openBet.event.eventId && newOpenBetsList[i].market.id === action.openBet.market.id && compareBetRacers(newOpenBetsList[i].racers, action.openBet.racers)) {
                    newMessageBar = getOpenBetMessage(DECREMENT_BET_VALUE, action.openBet);
                    newOpenBetsList[i] = action.openBet;
                    break;
                }
            }
            // remove open bets (if any) with no stake
            newOpenBetsList = newOpenBetsList.filter((oBet) => oBet.stake > 0);

            // store bets locally
            updateSimplifiedLocalOpenBets(state.playerUID, newOpenBetsList, newOpenBetsHistory);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsHistory: newOpenBetsHistory,
                messageBar: newMessageBar
            };

        case REMOVE_OPEN_BET:
            newOpenBetsList = state.openBetsList.slice();
            newOpenBetsHistory = state.openBetsHistory.slice();

            newOpenBetsList = newOpenBetsList.filter((openBet) => openBet.game.channel !== action.bet.game.channel || openBet.event.eventId !== action.bet.event.eventId || openBet.market.id !== action.bet.market.id || !compareBetRacers(openBet.racers, action.bet.racers));

            newOpenBetsHistory = newOpenBetsHistory.filter((openBetHistory) => openBetHistory.game.channel !== action.bet.game.channel || openBetHistory.event.eventId !== action.bet.event.eventId || openBetHistory.market.id !== action.bet.market.id || !compareBetRacers(openBetHistory.racers, action.bet.racers));

            // store bets locally
            updateSimplifiedLocalOpenBets(state.playerUID, newOpenBetsList, newOpenBetsHistory);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsHistory: newOpenBetsHistory
            };

        case REMOVE_ALL_BETS:
            newOpenBetsList = state.openBetsList.slice();
            newOpenBetsHistory = state.openBetsHistory.slice();

            newOpenBetsList = newOpenBetsList.filter((obl) => !(obl.game.channel === state.games[state.selectedGameIndex].channel && obl.event.eventId === state.selectedEventId));
            newOpenBetsHistory = newOpenBetsHistory.filter((obl) => !(obl.game.channel === state.games[state.selectedGameIndex].channel && obl.event.eventId === state.selectedEventId));

            // store bets locally
            updateSimplifiedLocalOpenBets(state.playerUID, newOpenBetsList, newOpenBetsHistory);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsHistory: newOpenBetsHistory,
                selectedEventMultiBetList: [],
                messageBar: defaultStoreValues.messageBar
            };

        case TOGGLE_COMMIT_BETS_SUCCESS:
            newGames = state.games.slice();

            newGames = newGames.map((game) => {
                if (game.channel === action.gameChannel) {
                    game.betsCommitted = !game.betsCommitted;
                }
                return game;
            });

            return {
                ...state,
                games: newGames
            };
        case TOGGLE_COMMIT_BETS_ERROR:
            newGames = state.games.slice();

            newGames = newGames.map((game) => {
                if (game.channel === action.gameChannel) {
                    game.betsFailedBeingCommitted = !game.betsFailedBeingCommitted;
                }
                return game;
            });

            return {
                ...state,
                games: newGames
            };
        case TOGGLE_COMMITTING_BETS:
            newGames = state.games.slice();
            newGames = newGames.map((game) => {
                if (game.channel === action.gameChannel) {
                    game.betsCommitting = !game.betsCommitting;
                }
                return game;
            });

            return {
                ...state,
                games: newGames
            };
        case ADD_LOCAL_STORED_BETS:
            return {
                ...state,
                openBetsList: action.openBetsList,
                openBetsHistory: action.openBetsHistory
            }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/reducers/openBetsReducer.js